import { NoteUiState } from '@/store/modules/noteUi/types'

export const state: NoteUiState = {
  interacted: false,
  loading: false,
}
